import { computed } from 'vue'
import { useUserStore } from '@/store/user'
import { buildLocalization, buildUnitLocalization } from '@/util'
import { MaterialPriceUtil } from './MaterialPriceUtil'
import { IMaterialPriceData } from './IMaterialPriceData'

export * from './IMaterialPriceData'
export * from './IMaterialDTO'
export * from './MaterialListItem'
export * from './MaterialTreeItem'

export function buildPriceFormatter() {
    const userStore = useUserStore()
    const userCurrency = computed(() => userStore.currency)

    const { localize } = buildLocalization()
    const { localizeUnit3 } = buildUnitLocalization()

    const priceFormatter = computed(() => userCurrency.value == null
        ? (() => new MaterialPriceUtil({ } as IMaterialPriceData, userCurrency.value ?? '', localize, localizeUnit3)) // don't show any price data, before currency has loaded!
        : ((data: IMaterialPriceData) => new MaterialPriceUtil(data, userCurrency.value ?? '', localize, localizeUnit3))
    )
    return { userCurrency, priceFormatter }
}